import { ListColumns } from "../pages/data-browser/enum/list-columns";

export const columnsList = [
    {
        id: ListColumns.LIST_ID,
        name: "List ID",
        width: 150,
    },
    {
        id: ListColumns.NAME,
        name: "List Name",
        width: 150,
        readonly: true,
    },
    {
        id: ListColumns.PARENT_LIST_ID,
        name: "Parent List ID",
        width: 150,
    },
    {
        id: ListColumns.PARENT_LIST_NAME,
        name: "Parent List Name",
        width: 150,
    },
    {
        id: ListColumns.HEADERS,
        name: "Data-Fields",
        width: 150,
    },
    {
        id: ListColumns.COUNTRY_NAME,
        name: "Country Name",
        width: 150,
    },
    {
        id: ListColumns.COUNTRY_CODE,
        name: "Country Code",
        width: 150,
    },
    {
        id: ListColumns.SOURCE_URL,
        name: "Source URL",
        width: 150,
    },
    {
        id: ListColumns.CATEGORY,
        name: "Category",
        width: 150,
    },
    {
        id: ListColumns.SIC_CODE,
        name: "SIC",
        width: 150,
    },
    {
        id: ListColumns.NAICS_PRIMARY,
        name: "NAICS Primary",
        width: 150,
    },
    {
        id: ListColumns.NAICS_SECONDARY,
        name: "NAICS Secondary",
        width: 150,
    },
    {
        id: ListColumns.RECORDS,
        name: "Location Count",
        width: 150,
    },
    {
        id: ListColumns.LAST_UPDATED,
        name: "Last Updated",
        width: 150,
    },
];
